import { Slider, Typography, Box, TextField } from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment'
import React from 'react'

import {
  addCommaToPrice,
  removeCommaFromPrice
} from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { Currency } from '../../../../types/currency'
import useStyles from './styles/index.styles'

interface PriceSliderProps {
  label?: string
  currency?: Currency
  min: number
  max: number
  price: number[]
  setPrice: (newRange: number[]) => void
}

const PriceSlider: React.FC<PriceSliderProps> = ({
  label,
  currency,
  min,
  max,
  price,
  setPrice
}) => {
  const classes = useStyles()

  const handleInputChange =
    (index: 0 | 1) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value
      const commaLessValue = removeCommaFromPrice(newValue)
      const numberValue = Number(commaLessValue)
      const updated = [...price] as number[]
      updated[index] = isNaN(numberValue) ? 0 : numberValue
      setPrice(updated)
    }

  const handleSliderChange = (
    event: React.ChangeEvent<{}> | Event,
    newValue: number | number[]
  ) => {
    if (Array.isArray(newValue)) {
      setPrice(newValue)
    }
  }

  return (
    <Box className={classes.root}>
      <Typography variant="h5" className={classes.text}>
        {getTranslate(label || '')}
      </Typography>
      <div className={classes.sliderContainer}>
        <Slider
          className={classes.slider}
          value={price}
          valueLabelFormat={(value) => (
            <span>
              {currency === 'IRR'
                ? `${value.toLocaleString()} ${currency}`
                : `$
              ${value.toLocaleString()} `}
            </span>
          )}
          valueLabelDisplay="off"
          onChange={handleSliderChange}
          min={min}
          max={max}
        />
      </div>
      <div className={classes.priceShow}>
        <TextField
          variant="outlined"
          placeholder="Minimum"
          value={addCommaToPrice(price[0])}
          onChange={handleInputChange(0)}
          className={classes.inputField}
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.input
            },
            endAdornment: (
              <InputAdornment position="end" className={classes.adornment}>
                {getTranslate(currency || '')}
              </InputAdornment>
            )
          }}
        />
        <TextField
          variant="outlined"
          placeholder="Maximum"
          value={addCommaToPrice(price[1])}
          onChange={handleInputChange(1)}
          className={classes.inputField}
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.input
            },
            endAdornment: (
              <InputAdornment position="end" className={classes.adornment}>
                {getTranslate(currency || '')}
              </InputAdornment>
            )
          }}
        />
      </div>
    </Box>
  )
}

export default PriceSlider
